import { render, staticRenderFns } from "./edit-alerte.vue?vue&type=template&id=2b1339e1&scoped=true&"
import script from "./edit-alerte.vue?vue&type=script&lang=ts&"
export * from "./edit-alerte.vue?vue&type=script&lang=ts&"
import style0 from "./edit-alerte.vue?vue&type=style&index=0&id=2b1339e1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b1339e1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VForm } from 'vuetify/lib/components/VForm';
import { VInput } from 'vuetify/lib/components/VInput';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTreeview } from 'vuetify/lib/components/VTreeview';
installComponents(component, {VBtn,VCard,VCheckbox,VForm,VInput,VSwitch,VTreeview})
